import URI from 'urijs';
import {NormalizedVideo, NormalizedVideoVendor} from "./NormalizedVideo";

export class YoutubeBlockObj {
    static isVideoUrl(url) {
        if(/youtu\.be/.exec(url)) {
            return true;
        }

        const urlTrim = url.replace(/\/?$/, "");
        const urlArr = urlTrim.split("/");
        const size = urlArr.length;

        if (urlArr[size - 2] == "user") {
            return false;
        }
        if (urlArr[size - 2] == "channel") {
            return false;
        }

        if (urlArr[size - 2] == "v") {
            return true;
        }

        const endArray = urlArr[size - 1];
        const urlArrEnd = endArray.split("?");

        return urlArrEnd[0] === "watch"
    }

    static isEmbedUrl(url) {
        const urlTrim = url.replace(/\/?$/, "");
        const urlArr = urlTrim.split("/");
        const size = urlArr.length;

        return urlArr[size - 2] === "embed";
    }

    static getVideoIdFromUrl(url: string): string {
        if(/http[s]?:\/\/youtu\.be/.exec(url)) {
            const urlTrim = url.replace(/\/$/, "");
            const urlArr = urlTrim.split("/");
            return urlArr[urlArr.length - 1];
        } else {
            // old style URL
            const parsedUrl = URI(url);

            // look for watch?v=<id>
            if (parsedUrl.hasQuery("v")) {
                const queryVariables = URI.parseQuery(parsedUrl.search());
                return queryVariables.v;
            } else {
                // maybe it's youtube.com/v/<id>
                const urlArr = parsedUrl.pathname().split("/");
                return urlArr[urlArr.length - 1];
            }
        }
    }

    static getVideoImage(id) {
        return `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
    }

    static getVideoPageLink(id) {
        return `https://www.youtube.com/watch?v=${id}`;
    }

    static getVideoUrl(id) {
        return `https://www.youtube-nocookie.com/embed/${id}`;
    }

    static getVideoById(id) {
        const video = new NormalizedVideo();
        video.vendor = NormalizedVideoVendor.YOUTUBE;
        video.id = id;
        video.viewLink = YoutubeBlockObj.getVideoPageLink(id);
        video.embedLink = YoutubeBlockObj.getVideoUrl(id) + "?modestbranding=1&showinfo=0&rel=0&autoplay=0";
        video.embedType = "iframe";
        video.poster = YoutubeBlockObj.getVideoImage(id);
        return video;
    }

    static getVideo(blockObj: IVideoBlockObj): NormalizedVideo | null {
        let video: NormalizedVideo | null = null;

        const url = blockObj.blockModel.json_data.block.settings.url;
        if (YoutubeBlockObj.isVideoUrl(url) || YoutubeBlockObj.isEmbedUrl(url)) {
            const videoId = YoutubeBlockObj.getVideoIdFromUrl(url);
            video = YoutubeBlockObj.getVideoById(videoId);
        }

        return video;
    }
}